"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Holder = exports.HolderWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.HolderWrapper = styled_components_1.default.div `
	width: 100%;
	max-width: ${props => props.theme.breakpoints.xl};
	margin: ${props => (props.marginVertical ? '2rem' : 0)} auto;
	padding: ${props => (props.isXsLayout ? 0 : '0 1em')};
`;
const Holder = ({ marginVertical = false, children, ...rest }) => {
    // TODO disscuss 0 padding on XS layout
    // const isXsLayout = useBreakpoint(only('xs'))
    return ((0, jsx_runtime_1.jsx)(exports.HolderWrapper, { marginVertical: marginVertical, ...rest, children: children }));
};
exports.Holder = Holder;
